import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Roles } from 'Core/enums';
import { AdminGuard } from 'Core/guards';
import { AppRoutes, shellRoutes, SuppliersRoute, workTemplatesRoute } from 'Core/routes';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { ShellComponent } from './shell/shell.component';

const defaultRoute = AppRoutes.APP;
const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: shellRoutes.DASHBOARD,
      },
      {
        path: shellRoutes.DASHBOARD,
        loadComponent: () => import('Modules/dashboard/dashboard.page').then(component => component.DashboardPage),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              Roles.ROLE_ADMIN,
              Roles.ROLE_DIRECTOR,
              Roles.ROLE_EMPLOYEE,
              Roles.ROLE_MANAGER,
              Roles.ROLE_SUPPLY_OFFICER,
              Roles.ROLE_SUPPLIER,
            ],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: shellRoutes.PROJECTS,
        loadChildren: () => import('Modules/projects/projects.module').then(m => m.ProjectsModule),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [Roles.ROLE_ADMIN, Roles.ROLE_DIRECTOR, Roles.ROLE_EMPLOYEE, Roles.ROLE_MANAGER, Roles.ROLE_SUPPLY_OFFICER],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: shellRoutes.PROJECT_AREA_PDF_SETTINGS,
        loadChildren: () =>
          import('Modules/project-area-pdf-settings/project-area-pdf-settings.module').then(m => m.ProjectAreaPdfSettingsModule),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [Roles.ROLE_ADMIN, Roles.ROLE_DIRECTOR, Roles.ROLE_EMPLOYEE, Roles.ROLE_MANAGER, Roles.ROLE_SUPPLY_OFFICER],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: shellRoutes.UNIT_TEMPLATES,
        loadChildren: () => import('Modules/unit-template/unit-templates.module').then(m => m.UnitTemplatesModule),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [Roles.ROLE_ADMIN, Roles.ROLE_DIRECTOR, Roles.ROLE_EMPLOYEE, Roles.ROLE_MANAGER, Roles.ROLE_SUPPLY_OFFICER],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: shellRoutes.WAREHOUSES,
        loadChildren: () => import('Modules/warehouses/warehouses.module').then(m => m.WarehouseModule),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [Roles.ROLE_ADMIN, Roles.ROLE_DIRECTOR, Roles.ROLE_SUPPLY_OFFICER],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: workTemplatesRoute.WORK_TEMPLATES,
        loadChildren: () => import('Modules/work-templates/work-templates.module').then(m => m.WorkTemplatesModule),
      },

      {
        path: shellRoutes.INVOICES,
        loadChildren: () => import('Modules/invoices/invoices.module').then(m => m.InvoicesModule),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [Roles.ROLE_ADMIN, Roles.ROLE_DIRECTOR, Roles.ROLE_EMPLOYEE, Roles.ROLE_MANAGER, Roles.ROLE_SUPPLY_OFFICER],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: SuppliersRoute.SUPPLIER,
        loadChildren: () => import('./../supplier/supplier.module').then(m => m.SupplierModule),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [Roles.ROLE_SUPPLIER],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: shellRoutes.FAVORITES,
        loadChildren: () => import('../favorite/favorite.module').then(m => m.FavoriteModule),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [Roles.ROLE_ADMIN, Roles.ROLE_DIRECTOR, Roles.ROLE_EMPLOYEE, Roles.ROLE_MANAGER, Roles.ROLE_SUPPLY_OFFICER],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: shellRoutes.CLIENT_SUPPLIER,
        loadChildren: () => import('./../client-supplier/client-supplier.module').then(m => m.ClientSupplierModule),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [Roles.ROLE_ADMIN, Roles.ROLE_DIRECTOR, Roles.ROLE_EMPLOYEE, Roles.ROLE_MANAGER, Roles.ROLE_SUPPLY_OFFICER],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: shellRoutes.ADMIN,
        loadChildren: () => import('./../admin/admin.module').then(m => m.AdminModule),
        canActivate: [ngxPermissionsGuard, AdminGuard],
        data: {
          permissions: {
            only: [Roles.ROLE_ADMIN],
            redirectTo: defaultRoute,
          },
        },
      },
      {
        path: shellRoutes.PERSONAL,
        loadChildren: () => import('./../personal/personal.module').then(m => m.PersonalModule),
      },
      {
        path: shellRoutes.CURRENCY_RATES,
        loadChildren: () => import('./../currency-rates/currency-rates.module').then(m => m.CurrencyRatesModule),
        canActivate: [ngxPermissionsGuard],
        data: {
          permissions: {
            only: [
              Roles.ROLE_ADMIN,
              Roles.ROLE_DIRECTOR,
              Roles.ROLE_EMPLOYEE,
              Roles.ROLE_MANAGER,
              Roles.ROLE_SUPPLY_OFFICER,
              Roles.ROLE_SUPPLIER,
            ],
            redirectTo: defaultRoute,
          },
        },
      },
    ],
  },
  { path: '**', pathMatch: 'full', redirectTo: defaultRoute },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShellRoutingModule {}
